import React from "react";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@volca/ui/components/ui/chart";
import { cn } from "@volca/ui/lib/utils";
import { CATEGORY_PALETTE } from "@volca/ui/tokens/chart-colors";
import { useGetBusinessWeeklyStats } from "@/business/query";
import { useBusiness } from "@/core/business";
import { CHART_FOCUS_CLASSES } from "./chart-focus";
import { DashboardChartCard } from "./dashboard-chart-card";

const chartConfig = {
  referral_count: {
    label: "Referrals",
    color: CATEGORY_PALETTE.purple,
  },
};

const ReferralsChartPane = React.memo(() => {
  const { businessId } = useBusiness();
  const {
    data = [],
    isLoading,
    isError,
  } = useGetBusinessWeeklyStats(businessId);
  const total = data.reduce((sum, week) => sum + week.referral_count, 0);

  return (
    <DashboardChartCard
      title="Referrals"
      total={total}
      caption={`over ${data.length} weeks`}
      isLoading={isLoading}
      errorMessage={
        isError ? "Couldn't load referrals. Please try again." : undefined
      }
    >
      <ChartContainer
        config={chartConfig}
        className={cn("aspect-auto h-56 w-full", CHART_FOCUS_CLASSES)}
      >
        <BarChart
          accessibilityLayer
          data={data}
          margin={{ left: 0, right: 8, top: 12 }}
        >
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          <XAxis
            dataKey="week_range"
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            tickFormatter={(value: string) => value.split(" - ")[0]}
          />
          <YAxis
            width={32}
            tickLine={false}
            axisLine={false}
            tickMargin={4}
            allowDecimals={false}
          />
          <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
          <Bar
            dataKey="referral_count"
            fill={chartConfig.referral_count.color}
            radius={[4, 4, 0, 0]}
            maxBarSize={20}
          />
        </BarChart>
      </ChartContainer>
    </DashboardChartCard>
  );
});

export default ReferralsChartPane;
